import { combineComponents } from "~utils";

import { BoardPersistenceProvider } from "./board";
import { BoardTypePersistenceProvider } from "./board-type";
import { FeedbackPersistenceProvider } from "./feedback";
import { FormationPersistenceProvider } from "./formation";
import { PreferencesPersistenceProvider } from "./preferences";
import { SharedFormationPersistenceProvider } from "./shared-formation";
import { TeamPersistenceProvider } from "./team";
import { UserPersistenceProvider } from "./user";

export const FirestoreProvider = combineComponents(
  BoardPersistenceProvider,
  BoardTypePersistenceProvider,
  FeedbackPersistenceProvider,
  FormationPersistenceProvider,
  PreferencesPersistenceProvider,
  SharedFormationPersistenceProvider,
  TeamPersistenceProvider,
  UserPersistenceProvider,
);
